export default {
  city: (data, p) => ({
    title: `Запчасти для грузовиков купить ${p.inCity} - Автобазар`,
    title_uk: `Запчастини для вантажівок купити ${p.inCity} - Автобазар`,

    description: `Купить запчасти на грузовик ${p.inCity}. Большой каталог автозапчастей для грузовиков ${p.inCity} на Автобазар. В продаже запчасти к грузовикам бу и новые от по выгодным ценам`,
    description_uk: `Купити запчастини на грузовик ${p.inCity}. Великий каталог автозапчастин для вантажівок ${p.inCity} на Автобазар. У продажу запчастини до вантажівок бу і нові від за вигідними цінами`,

    header: `Запчасти для грузовиков ${p.inCity}`,
    header_uk: `Запчастини для вантажівок ${p.inCity}`,
  }),

  make_model: (data, p) => ({
    header: `Запчасти для грузовиков ${data.make} ${data.model}`,
    header_uk: `Запчастини для вантажівок ${data.make} ${data.model}`,
  }),
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/gruzovye/templates.js